export default __webpack_public_path__ + "media/images/_blank-995eb6adebe85429f1be2e74cbd1817e.png";